import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

export default styled(Grid)(() => ({
  backgroundColor: "orange",
  paddingTop: 0,
}));
